<template>
<div class="chapter">
<div class="inner_page">
<p class="p11"><span class="sz"><b>Acknowledgments</b></span></p>
<div style="text-align:center"><img alt="flourish" src="images/flourish.png"/></div>
<p class="p13"><span class="sz"><span class="s3">I</span> want to thank my beta readers—Toni Echols, Marliss Melton, and PR. This was a better story because of all your input. And I offer my undying gratitude to my editor, Chloe Bearuski, who as usual infused my writing with her grace and composure.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section5.vue?019097cc